<template>
  <div class="app-container">
    <div class="box">
      <div class="title">此操作将会重新整理可用量，是否开始整理？</div>
      <div class="main">
        <div>说明</div>
        <div>1、当可用量出现异常时, 可通过可用量重整工具处理</div>
        <div>2、当可用量重整时, 其他业务均不能操作, <span style="font-size: 20px; color: red;">请在无人使用时重整</span></div>

        <div class="btn_box">
          <el-button @click="getAvailableReset">开始</el-button>
          <el-button>取消</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";


export default {
  mixins: [curdMixins],
  data(){
    return {
      api: require("@/api/stock/stProductStock").default,
    }
  },
  methods: {
    getAvailableReset(){
      this.api.changeExistQuantity().then(res => {
        if(res.Code === 0){
          this.$message({type: 'success', message: "操作成功"})
        }else{
          this.$message({type: 'warning', message: res.Msg})
        }
       })
    }
  }
  
};
</script>

<style lang="scss" scoped>
  .box{
    width: 600px;
    background: #f5f5f5;
    margin: auto;
    margin-top: 60px;

    &::before{
      content: "";
      display: table;
    }

    .title{
      font-weight: bold;
      font-size: 18px;
      margin: 0 54px;
      margin-top: 60px;
    }

    .main{
      margin: 0 54px;

      .btn_box{
        padding: 18px 0;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
</style>